export {
  DELIVERY_METHOD,
  DELIVERY_DESCRIPTION,
  MIN_COST_DELIVERY_FREE,
} from './constants';
